import { createActionCreator } from "common/ReduxUtils";
import { CreateShipmentActionTypes } from "../CreateShipmentActionTypes";
import { CreateShipmentMetaState } from "../CreateShipmentState";

export const setSavedFreightServiceTitle = createActionCreator<CreateShipmentMetaState["savedFreightServiceTitle"]>(
  CreateShipmentActionTypes.SET_SAVED_FREIGHT_SERVICE_TITLE,
  "savedFreightServiceTitle"
);
